import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
})
export class ErrorComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/spina-me/source/src/app/error/error.component.ts